export const LayoutToken = {
  sider: {
    colorMenuBackground: "#fff",
    colorTextMenu: "#61605F",
    colorTextMenuTitle: "#61605F",

    colorBgMenuItemHover: "#F3EDE1",
    colorTextMenuItemHover: "#5E4130",
    colorTextMenuHover: "#5E4130",

    colorBgMenuItemActive: "#E6D9C2",
    colorTextMenuActive: "#5E4130",

    colorTextMenuSelected: "#5E4130",
    colorBgMenuItemSelected: "#F9F6F0",
  },
  pageContainer: { colorBgPageContainer: "#F8F8F8" },
};
